
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getITree",
      resolverType: "query",
      routePath: "/getITree",
      httpMethod: "POST",
    });
  